import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'min-validation-error',
  standalone: false,
  templateUrl: './min-validation-error.component.html',
  styleUrl: './min-validation-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MinValidationErrorComponent {
  public label = input.required<string>();
  public min = input.required<number>();
  
  constructor() {}  
}
